import { UiBox, UiSocialButton } from "@smp/ui";
import { REACT_APP__IS_FOREIGN } from "@smp/utils";
import { useMemo } from "react";

import { useHumanizer } from "@/hooks/use_humanizer";

import { DEFAULT_WHITELIST } from "./social_links.static";
import { IProps } from "./social_links.types";

export const SocialLinks = ({
  BoxChildProps,
  whiteList = DEFAULT_WHITELIST,
}: IProps) => {
  const { humanize } = useHumanizer();

  const handleClick = (
    medium:
      | "vk"
      | "instagram"
      | "facebook"
      | "telegram"
      | "twitter"
      | "youtube",
  ) => {
    switch (medium) {
      case "facebook":
        return window.open(
          REACT_APP__IS_FOREIGN
            ? "https://www.facebook.com/smmplanner"
            : "https://www.facebook.com/smmplanner.ru",
          "_blank",
          "noopener",
        );
      case "instagram":
        return window.open(
          "https://www.instagram.com/smmplanner/",
          "_blank",
          "noopener",
        );
      case "telegram":
        return window.open(
          "https://telegram.me/smmplanner",
          "_blank",
          "noopener",
        );
      case "twitter":
        return window.open(
          "https://twitter.com/smmplanner",
          "_blank",
          "noopener",
        );
      case "vk":
        return window.open("https://vk.com/smmplanner", "_blank", "noopener");
      case "youtube":
        return window.open(
          "http://www.youtube.com/channel/UCMRGvjeSQODa0xXbn_Od2Wg",
          "_blank",
          "noopener",
        );
    }
  };

  const filteredSocialIcons = useMemo(
    () =>
      REACT_APP__IS_FOREIGN ? (
        <UiBox key="facebook" {...BoxChildProps}>
          <UiSocialButton
            onClick={handleClick}
            medium="facebook"
            tooltip={humanize("facebook")}
          />
        </UiBox>
      ) : (
        whiteList.map((medium: typeof DEFAULT_WHITELIST[number]) => (
          <UiBox key={medium} {...BoxChildProps}>
            <UiSocialButton
              isDisplayingIconDangerous={!REACT_APP__IS_FOREIGN}
              onClick={handleClick}
              medium={medium}
              tooltip={humanize(medium)}
            />
          </UiBox>
        ))
      ),
    [BoxChildProps, humanize, whiteList],
  );

  return useMemo(
    () => (
      <UiBox
        alignItems="center"
        display="flex"
        flexDirection="row"
        justifyContent="center"
      >
        {filteredSocialIcons}
      </UiBox>
    ),
    [filteredSocialIcons],
  );
};
